export const base_table = { page: 1, per_page: 100, order_by: "estate_name", order_dir: "asc" };

export const base_object = { is_active: false, lower_margin: null, upper_margin: null };
